export let es_lang = {
  "leaf.application-changer.applications" : "Aplicaciones",
  "leaf.common.signout" : "Salir",
  "leaf.common.options" : "Opciones"
}
